import React, { useState, useMemo } from "react";
import { uniq } from "lodash";
import {
    Box,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    Grid,
    Divider,
    DialogActions,
    Button,
    Paper,
    DialogContentText,
    Typography
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import { strings } from "../../../../../common/i18n";
import { useDispatch, useSelector } from "react-redux";
import { enums, format } from "../../../../../common/lib";
import Excluded from "./Excluded";
import styles from "../styles";
import AssetProgresBar from "../../../../../common/components/AssetProgresBar";
import DonutChart from "../../../../../common/components/DonutChart";
import actions from "../../../../../Store/actions";
import useViewAuditHelper from "../useViewAuditHelper";
import { useShouldShowCloseAuditPopup } from "../../../../../common/hooks";
import AssetStatus from "../../../../../common/components/AssetStatus";

/**
 * Audit Review Summary Assets Component
 */

export default ({ onToggleView }) => {
    const { auditsList } = useSelector((state) => state);
    const dispatch = useDispatch();
    const isClosedAudit = auditsList.item?.status === enums.status.audit.closed;

    const {
        auditorAssetStatus,
        controllerExclusionSummary,
        summaryData,
        donutValues,
        data
    } = useViewAuditHelper();

    return (
        <>
            {isClosedAudit && (
                <Typography variant="subtitle2" gutterBottom>
                    {strings("messages.auditCloseView")}
                </Typography>
            )}
            <Grid container>
                <Grid item sm={12} md={6} lg={6} xl={6} p={2}>
                    <Typography variant="body1">
                        {strings("auditDetail")}
                    </Typography>
                    <Divider sx={styles.spacer} />
                    <Box sx={styles.flexContainer}>
                        <Typography variant="body2" component="p">
                            {strings("createdDate")}
                        </Typography>
                        <Typography variant="body2">
                            {format.dateTimeNew(auditsList.item.createdDate)}
                        </Typography>
                    </Box>
                    <Box sx={styles.flexContainer}>
                        <Typography variant="body2" component="p">
                            {strings("submittedDate")}
                        </Typography>
                        <Typography variant="body2">
                            {format.dateTimeNew(
                                auditsList.item.latestSubmissionDate
                            )}
                        </Typography>
                    </Box>
                    <Box sx={styles.flexContainer}>
                        <Typography variant="body2" component="p">
                            {strings("controller")}
                        </Typography>
                        <Typography variant="body2">
                            {summaryData.controllers}
                        </Typography>
                    </Box>

                    <Divider sx={styles.spacer} />
                    <Typography variant="body1">
                        {strings("auditors")}
                    </Typography>

                    {auditorAssetStatus &&
                        auditorAssetStatus.map((item, id) => (
                            <Grid
                                key={`${id}-${item.auditor}`}
                                sx={styles.flexContainer}
                            >
                                <Grid item xs={4}>
                                    <Typography
                                        sx={styles.label}
                                        variant="body2"
                                    >
                                        {item?.auditor?.displayName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <AssetProgresBar data={item} />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    variant="body2"
                                    sx={{ textAlign: "center" }}
                                >
                                    <AssetStatus status={item.auditorStatus} />
                                </Grid>
                            </Grid>
                        ))}
                    <Divider sx={styles.spacer} />

                    {controllerExclusionSummary.length > 0 && (
                        <>
                            <Typography variant="body1">
                                {strings("controllerExcluded")}
                            </Typography>
                            {controllerExclusionSummary.map((item) => (
                                <Grid
                                    key={item.controller?.id}
                                    sx={styles.flexContainer}
                                >
                                    <Grid item xs={8}>
                                        <Typography
                                            sx={styles.label}
                                            variant="body2"
                                        >
                                            {item.controller?.displayName}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={4}
                                        sx={{ textAlign: "center" }}
                                    >
                                        <Typography variant="body2">
                                            {item.excludedCount}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ))}
                            <Divider sx={styles.spacer} />
                        </>
                    )}

                    {/* <Typography variant="body1">
                        {strings("assetDetail")}
                    </Typography> */}
                    {/* <Divider sx={styles.spacer} /> */}
                    <DonutChart
                        data={donutValues}
                        onToggleView={onToggleView}
                    />
                    <Divider sx={styles.spacer} />
                </Grid>
                <Grid item sm={12} md={6} lg={6} xl={6} p={2}>
                    <Excluded value={data} />
                </Grid>
            </Grid>
        </>
    );
};

/** TODO
 *
 * After the view is finalised do the clean up
 */
